import { OccupancyType, Project } from '../../types/project';
import { defaultEditionForState, getEditionPack } from './editions';
import { checkTraditionalEligibility } from './eligibility';

// The scope statement: what the service feeds, how it is configured, and why
// the section applies. The eligibility gate collected these answers from the
// start, but until the 2026-09-02 audit nothing printed them — an inspector
// reading a 220.83 worksheet saw the arithmetic and never the qualification
// it rests on. Printed on the report's Dwelling Profile block and shown on
// the Results tab.

export function occupancyLabel(type: OccupancyType | null | undefined): string {
  switch (type) {
    case 'one-family':
      return 'Single-family dwelling unit';
    case 'dwelling-unit':
      return 'One dwelling unit within a two-family or multifamily building (its own feeder or service)';
    case 'multifamily-building':
      return 'Whole multifamily building service';
    case 'non-dwelling':
      return 'Non-dwelling occupancy';
    default:
      return 'Occupancy not stated';
  }
}

/** Null when the project is outside the section's scope: nothing may print a
 * qualification the project does not hold. */
export function qualificationStatement(project: Partial<Project>): string | null {
  if (!checkTraditionalEligibility(project).eligible) return null;
  const pack = getEditionPack(
    project.code_edition ?? defaultEditionForState(project.customer_state)
  );
  const config =
    project.service_voltage_text ||
    (project.service_voltage_numeric ? `${project.service_voltage_numeric} V` : '');
  const service = [config, '3-wire'].filter(Boolean).join(' ');
  const amps = project.service_rating_amps ? `, ${project.service_rating_amps} A` : '';
  return `${occupancyLabel(project.occupancy_type)}; ${service} service${amps}. Qualifies for NEC ${pack.sectionMap.existingDwelling}: a dwelling unit served by a 120/240 V or 208Y/120 V 3-wire service or feeder, with no minimum service size.`;
}
